import { actions } from 'data'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

// Clicked email link to verify email account
const EmailVerification = () => {
  const dispatch = useDispatch()
  const { code, id } = useParams()

  useEffect(() => {
    if (!id || !code) return
    dispatch(actions.signup.resumeEmailVerification(id, code))
  }, [])

  return null
}

export default EmailVerification
